import React from 'react';
import './ThumbnailBadge.css';

export const ThumbnailBadge = ({
    badgeName,
    badgeText,
}) => {
    return (
        <div
            className={`casino-thumbnail__badge casino-thumbnail__badge--${badgeName}`}
        >
            <div className="casino-thumbnail__badge-icon" />
            {badgeText}
        </div>
    );
};
